import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../../graphql/types.generated';
export type UploadBookingDocumentMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UploadInput;
}>;

export type UploadBookingDocumentMutationResult = { __typename?: 'Mutation' } & {
  bookingDocumentUpload?: GraphQLTypes.Maybe<
    { __typename?: 'UploadPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UploadBookingDocumentDocument = gql`
  mutation uploadBookingDocument($input: UploadInput!) {
    bookingDocumentUpload(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
